export default __webpack_public_path__ + "static/media/404-01.8782ad1f.svg";